// @generated by `pnpm sync:specs` — DO NOT EDIT BY HAND.
// Derived from the synced page specs in src/develocity-ai/content/{platform,solution}-pages/
// (meta.slug → meta.title), regenerated on every sync. The drift guard in
// product-interest.test.ts asserts this mirrors loadProductNameMap() from the catalog.

/** Capability/solution page slug → product display name. */
export const PRODUCT_INTEREST_NAMES = {
  ai: 'AI',
  android: 'Android',
  'artifact-cache': 'Artifact Cache',
  'artifact-governance': 'Artifact Governance',
  'build-cache': 'Build Cache',
  'build-caching-optimizer': 'Build Caching Optimizer',
  'build-scan': 'Build Scan',
  'build-systems-package-managers': 'Build Systems & Package Managers',
  'context-engineering-overview': 'Context Engineering',
  'deployment-options': 'Deployment Options',
  'develocity-agents': 'Develocity Agents',
  'develocity-analytics': 'Develocity Analytics',
  dora: 'DORA',
  efficiency: 'Efficiency',
  'failure-analytics': 'Failure Analytics',
  'failure-handler': 'Failure Handler',
  'flaky-tests-detection': 'Flaky Tests Detection',
  'how-develocity-works': 'How Develocity Works',
  integrations: 'Integrations',
  'mcp-servers': 'MCP Servers',
  'metadata-enrichment': 'Metadata Enrichment',
  'observability-data-platform': 'Observability Data Platform',
  'on-demand-auditing': 'On-Demand Auditing',
  'performance-insights': 'Performance Insights',
  'policy-scan': 'Policy Scan',
  'predictive-test-selection': 'Predictive Test Selection',
  'repository-managers': 'Repository Managers',
  'security-compliance': 'Security & Compliance',
  'setup-cache': 'Setup Cache',
  'software-governance': 'Software Governance',
  'software-modernization': 'Software Modernization',
  'test-distribution': 'Test Distribution',
  'universal-cache': 'Universal Cache',
} as const satisfies Record<string, string>;

/** A synced capability/solution page slug (a PRODUCT_INTEREST_NAMES key). */
export type ProductInterestSlug = keyof typeof PRODUCT_INTEREST_NAMES;
